import React, { ReactNode } from 'react';
import './index.less';
import { environment } from '@gaodun.com/gtools';
import { ICorrectType, IQuestionListItem } from '@/types';
import CpaCorrectText from './cpa-ai-text';
import SheetTable from '../luckysheet/sheet-table';
import CpaCorrectCategory from './cpa-ai-category';

interface IProps {
    questionItem: IQuestionListItem;
    children: ReactNode;
}

const cpaCorrectContent: React.FC<IProps> = props => {
    const { aiCorrect, score, projectId, subjectId } = props.questionItem;
    const { correctStatus, totalScoreStr, totalScore } = aiCorrect!;

    const makeCpaCorrectComponents = (item: ICorrectType, isShowCardScore: boolean) => {
        switch (item.answerType) {
            case 'text': // 文本批改
                return item.correctText ? (
                    <>
                        <div className="ai-correct-card-total-score">
                            {isShowCardScore && (
                                <span className="score-tips">
                                    文本得分：<span className="score-tips-large">{item.correctText.userScore}</span>/
                                    {item.correctText.questionScore}分
                                </span>
                            )}
                        </div>
                        <CpaCorrectText data={item.correctText} />
                    </>
                ) : (
                    ''
                );
            case 'table': // 表格
                return item.correctTable ? (
                    <>
                        <div className="ai-correct-card-total-score">
                            {isShowCardScore && (
                                <span className="score-tips">
                                    表格得分：<span className="score-tips-large">{item.correctTable.userScore}</span>/
                                    {item.correctTable.questionScore}分
                                </span>
                            )}
                            {item.correctTable.tableStatus === 5 && <span className="blank-process">缺乏计算过程，表格得分为0</span>}
                        </div>
                        <SheetTable data={item.correctTable} />
                    </>
                ) : null;
            case 'category': // 会计分录
                return item.correctAccountCategory ? (
                    <>
                        <div className="ai-correct-card-total-score">
                            {isShowCardScore && (
                                <span className="score-tips">
                                    文本得分：<span className="score-tips-large">{item.correctAccountCategory.userScore}</span>/
                                    {item.correctAccountCategory.questionScore}分
                                </span>
                            )}
                        </div>
                        <CpaCorrectCategory data={item.correctAccountCategory} />
                    </>
                ) : null;
            default:
                return null;
        }
    };

    const goComment = () => {
        window.open(
            `https://${environment.getApiEnv()}muses.gaodun.com/ape/evaluation-page?businessUnitId=${
                aiCorrect!.id
            }&scene=15&version=体验监测V1.0&projectId=${projectId}&subjectId=${subjectId}`
        );
    };

    const renderCpaStatusCorrect = () => {
        switch (correctStatus) {
            case 1:
                return (
                    <div className="ai-correct-loading">
                        <img
                            className="ai-header-img"
                            src="https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202310/30/04c33_20231030162720.png"
                        />
                        <div>批改需3-10分钟。请先做其他学习，结果稍后显示。感谢等待。</div>

                        <img
                            className="ai-voice-img"
                            src="https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202305/24/5f1c5_20230524160726.gif"
                        />
                    </div>
                );
            case 2:
            case 6:
                return (
                    <div className="ai-correct-content">
                        <div className="ai-correct-contnet-header">
                            <img
                                className="ai-header-img"
                                src="https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202310/30/04c33_20231030162720.png"
                            />
                            <div style={{ width: 180 }}>
                                总得分: <span>{totalScore}</span> / {score}分
                            </div>
                            <div style={{ marginLeft: 50 }}>{totalScoreStr}</div>
                        </div>

                        <div className="ai-correct-main">
                            <div className="ai-answer-title ">你的回答</div>

                            {aiCorrect?.corrects.map((item, index) => {
                                return (
                                    <div
                                        className="ai-correct-card  ai-match-content cpacorrect"
                                        key={`${item.answerType}-${index.toString()}`}
                                    >
                                        {makeCpaCorrectComponents(
                                            item,
                                            JSON.stringify(aiCorrect.corrects).includes('text') &&
                                                JSON.stringify(aiCorrect.corrects).includes('table')
                                        )}
                                    </div>
                                );
                            })}

                            <div className="ai-flex-item">
                                <div className="ai-comment">
                                    <div onClick={goComment}>
                                        意见反馈
                                        <img src="https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202308/15/75811_20230815154404.png" />
                                    </div>
                                </div>
                                <div className="ai-main-tip">温馨提示：批改结果仅供参考，如有疑问，欢迎反馈</div>
                            </div>
                        </div>
                    </div>
                );
            case 3:
                return (
                    <div className="ai-correct-failure">
                        <img
                            className="ai-header-img"
                            src="https://simg01.gaodunwangxiao.com/uploadfiles/tmp/upload/202308/03/7cbe5_20230803143010.png"
                        />
                        <div>批改失败。可能是太拥挤了，可稍后再来尝试</div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <>
            {renderCpaStatusCorrect()}
            {aiCorrect && [0, 1, 3].includes(aiCorrect.correctStatus) && props.children}
        </>
    );
};

export default cpaCorrectContent;
